import projectModel from './project'

export { projectModel }
